import { Component, OnInit } from '@angular/core';
import { FormGroup,FormControl,Validator, Validators } from '@angular/forms';
import { CanActivate, Router } from '@angular/router';
import { UsuarioPanel } from 'app/models/usuarioPanel.interface';
import { RecuperarContraseñaService } from 'app/services/recuperar-contraseña.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationComponent } from 'app/shared/notification/notification.component';
import { SpinnerService } from '../../services/spinner.service';
import { camposFaltantes } from '../../utils/form-errors.utils';

@Component({
  selector: 'app-enviar-mail-medico',
  templateUrl: './enviar-mail-medico.component.html',
  styleUrls: ['./enviar-mail-medico.component.scss']
})
export class EnviarMailMedicoComponent implements OnInit {


  mailForm:FormGroup;

  constructor(
    private router:Router,
    private apiRCS:RecuperarContraseñaService,
    private snackBar:MatSnackBar,
    private spinService:SpinnerService,
  ) { 
    this.iniciarFormularion();
  }


  ngOnInit(): void {}

  
  iniciarFormularion(){
    this.mailForm = new FormGroup({
      email : new FormControl('',[Validators.required,Validators.email])
    });
  }


  enviarMail(form:any){
    if(this.mailForm.invalid){
      this.openSnackBar(camposFaltantes(this.mailForm, { email: 'Email' }),'error');
      return;
    }
    this.spinService.mostrarSpinner();
    this.apiRCS.recuperarMedico(form).subscribe(
      data => {
        this.spinService.ocultarSpinner();
        this.openSnackBar("Si el email está registrado, te llegará un correo para cambiar la contraseña","exito");
      },
      error=>{
        this.spinService.ocultarSpinner();
        if(error?.status >= 400 && error?.status < 500) this.openSnackBar("Si el email está registrado, te llegará un correo para cambiar la contraseña","exito");
        else this.openSnackBar("No se pudo enviar el email, probá más tarde","error");
      }
    )
  }


  openSnackBar(message: string, action: string) {
    this.snackBar.openFromComponent(NotificationComponent,{
      data: {
        message : message,
        action : action
      },
      duration:2500,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass : [action]
    });
  }

}
